import venturesImage from "../../../img/homeVenturesProgram.svg";
import consultingImage from "../../../img/homeConsultingProgram.svg";
import eventsImage from "../../../img/homeEventsProgram.svg";
import num1 from "../../../img/num1.svg";
import num2 from "../../../img/num2.svg";
import num3 from "../../../img/num3.svg";

export const programs = [
  {
    name: "VENTURES",
    description:
      "Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit.",
    numberIcon: num1,
    img: venturesImage,
    navLink: "/Ventures"
  },
  {
    name: "ELEVATE",
    description:
      "Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit.",
    numberIcon: num2,
    img: consultingImage,
    navLink: "/Consulting"
  },
  {
    name: "EVENTS",
    description:
      "Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit.",
    numberIcon: num3,
    img: eventsImage,
    navLink: "/Events"
  },
];
